import React from "react"
import { StyleSheet } from "react-native"

import { IMAGE_HOST_URL } from "@/constants/imgix"
import { Image, useCurrentColorMode } from "@/theme"

import type { ColorModeValue } from "@/theme"
import type { ImageProps } from "react-native"

type FarmHqLogoFilename =
  | "farmhq-leaf-iso.png"
  | "farmhq-logo-inline.png"
  | "farmhq-logo-stacked.png"

interface Props extends Omit<ImageProps, "source"> {
  name: FarmHqLogoFilename
}
export function getFarmHqLogoUri(
  name: FarmHqLogoFilename,
  colorMode: ColorModeValue,
) {
  return `${IMAGE_HOST_URL}/logos/${colorMode}/${name}`
}
export function useFarmHqLogUri(name: FarmHqLogoFilename) {
  const colorMode = useCurrentColorMode()
  return { uri: getFarmHqLogoUri(name, colorMode) }
}

const DEFAULT_SIZE = 36
const styles = StyleSheet.create({
  root: {
    height: DEFAULT_SIZE,
    width: DEFAULT_SIZE,
  },
})

export function FarmHqLogo({
  alt = "FarmHQ",
  name,
  ...rest
}: Props): React.JSX.Element {
  const logoUrl = useFarmHqLogUri(name)

  return <Image style={styles.root} {...rest} alt={alt} source={logoUrl} />
}
